import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Webcam from "react-webcam";
import { useParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import SignatureCanvas from "react-signature-canvas";
import { FILE_BASE_URL } from "./Constatnt";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import {
  UpsertSeedDistribution,
  GetUserDataforSeedDistribution,
} from "./Common";
import Select from "react-select";

const getRandomColor = () => {
  const colors = [
    "#FFB3BA",
    "#FFDFBA",
    "#FFFFBA",
    "#BAFFC9",
    "#BAE1FF",
    "#E6EEFF",
    "#FFF0F5",
    "#F0FFF0",
    "#E0FFFF",
    "#FFFACD",
    "#F5DEB3",
    "#FFDAB9",
    "#E0BBE4",
    "#D5AAFF",
    "#B5EAD7",
    "#FFDAC1",
    "#C7CEEA",
    "#D3F8E2",
    "#FFCBC1",
    "#E2F0CB",
    "#F1F0C0",
    "#AFCBFF",
    "#FFC9DE",
    "#C9F9FF",
    "#D0F0C0",
    "#FDE2E4",
    "#F9F9C5",
    "#FFE5B4",
    "#D8E2DC",
    "#F0E5CF",
    "#CCE2CB",
    "#F6DFEB",
    "#F3F4ED",
    "#FAF4B7",
    "#D9F8C4",
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

const DataCollection = () => {
  const [borderColor, setBorderColor] = useState("");
  const [signaturePreview, setSignaturePreview] = useState(null);
  const [isFingerprintModalOpen, setFingerprintModalOpen] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const currentYear = new Date().getFullYear();
  const { orgCode, userId } = useParams();
  const [imageSrc, setImageSrc] = useState("");
  const [userData, setUserData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [penColor, setPenColor] = useState("#0000ff");
  const sigRef = useRef(null);
  const dateInputRef = useRef(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [facingMode, setFacingMode] = useState("user");
  const [capturedImage, setCapturedImage] = useState(null);
  const [step, setStep] = useState("camera"); // 'camera' or 'preview'
  const navigate = useNavigate();
  const cropOptions = [{ id: 2000, name: "Cotton" }];
  const webcamRef = useRef(null);

  const handleNavigate = () => {
    navigate(`/list/${orgCode}`); // replace with your actual route
  };

  const varietyOptions = [
    { id: 2001, name: "PADMA 141" },
    { id: 2002, name: "PADMA VASUDHA 1318 GOLD" },
    { id: 2003, name: "PARTECH 300" },
    { id: 2004, name: "ASHA NON BT" },
    { id: 2005, name: "PARSHV-909" },
    { id: 2006, name: "PARSHV-101" },
  ];

  const lotOptions = [
    "MRHP25-APR-43",
    "MRHP25-APR-44",
    "MRHP25-APR-45",
    "MRHP25-APR-91",
    "MRHP25-APR-92",
    "MRHP25-APR-93",
    "MRHP25-APR-94",
    "2024-909-7751",
    "2024-101-4401",
    "1119",
    "1121",
    "1122",
    "AGN425121",
  ];

  const [formData, setFormData] = useState({
    Org_Code: orgCode,
    User_ID: userId,
    Year: currentYear,
    Crop_ID: cropOptions[0].id,
    Variety_ID: varietyOptions.id,
    LotNo: "",
    No_Of_Packet: "",
    Date_of_Distributation: "",
    Signature_Pad: "",
    Signature_Thumb: "",
    Farmer_Image: "",
    Add_By_User: userId,
    Update_By_User: userId,
  });

  useEffect(() => {
    setBorderColor(getRandomColor());
  }, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: false })); // clear error on change
  };

  const varietySelectOptions = varietyOptions.map((variety) => ({
    value: variety.id,
    label: variety.name,
  }));

  const lotSelectOptions = lotOptions.map((lot) => ({
    value: lot,
    label: lot,
  }));

  const yearOptions = Array.from({ length: 2050 - 2022 + 1 }, (_, i) => {
    const year = 2022 + i;
    return { value: year, label: year.toString() };
  });

  const handleSubmit = async () => {
    const errors = {};

    if (!formData.Year) errors.Year = "Year is required";
    if (!formData.Crop_ID) errors.Crop_ID = "Crop name is required";
    if (!formData.Variety_ID) errors.Variety_ID = "Variety is required";
    if (!formData.LotNo.trim()) errors.LotNo = "Lot No is required";
    if (!formData.No_Of_Packet)
      errors.No_Of_Packet = "Number of packets is required";
    if (!formData.Date_of_Distributation)
      errors.Date_of_Distributation = "Date of distribution is required";
    // if (!formData.Signature_Thumb && !formData.Signature_Pad) {
    //   errors.Signature_Thumb =
    //     "Please scan your thumb or provide a digital signature.";
    //   errors.Signature_Pad =
    //     "Please scan your thumb or provide a digital signature.";
    // }
    // if (!formData.Farmer_Image) errors.Farmer_Image = "Image is required";

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    try {
      const response = await UpsertSeedDistribution({
        ...formData,
        Year: parseInt(formData.Year),
        Crop_ID: parseInt(formData.Crop_ID),
        Variety_ID: parseInt(formData.Variety_ID),
      });

      const result = response.data;

      if (result.status === 200 || result.status === 201) {
        Swal.fire({
          title: "Data Submitted Successfully",
          text: result.message || "Your data has been submitted successfully.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/"); // ✅ Redirection works here after "OK"
        });
      } else {
        Swal.fire({
          title: "Submission Failed",
          text: result.message || "There was an error submitting your data.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error("API Error:", err);
      Swal.fire({
        title: "Network Error",
        text: "Unable to submit data. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const errorStyle = "border-red-500";
  useEffect(() => {
    // API call happens here on every mount/refresh
    const fetchData = async () => {
      try {
        const response = await GetUserDataforSeedDistribution({
          User_ID: userId,
          Org_Code: orgCode,
        });

        setUserData(response.data.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, []);
  const captureFP = () => {
    callSGIFPGetData(successFunc, errorFunc);
  };

  const successFunc = (result) => {
    if (result.ErrorCode === 0) {
      if (result.BMPBase64?.length > 0) {
        setImageSrc("data:image/bmp;base64," + result.BMPBase64);
      }
    } else {
      alert("Fingerprint Capture failed. Error Code: " + result.ErrorCode);
    }
  };

  const errorFunc = () => {
    alert(
      "Fingerprint service not detected!\n\nPlease install and start the SecuGen WebAPI service.\n\nYou will now be redirected to download the setup."
    );
    window.open(
      "https://yourdomain.com/downloads/SGI_BWAPI_S_Win_32bit_1.0.0.41.exe", // Host this on your server
      "_blank"
    );
  };

  const callSGIFPGetData = (successCall, failCall) => {
    const uri = "https://localhost:8000/SGIFPCapture";
    const xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4) {
        if (xmlhttp.status === 200) {
          try {
            const fpObject = JSON.parse(xmlhttp.responseText);
            successCall(fpObject);
          } catch (err) {
            alert("Failed to parse fingerprint response.");
          }
        } else {
          failCall(xmlhttp.status);
        }
      }
    };

    xmlhttp.onerror = function () {
      failCall(xmlhttp.status);
    };

    xmlhttp.open("POST", uri, true);
    xmlhttp.send();
  };

  const toggleModal = () => setIsOpen(!isOpen);

  const clearSignature = () => {
    if (sigRef.current) {
      sigRef.current.clear();
    }
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";

    // Only allow image/png or jpeg, force it if needed
    const allowedMime = ["image/png", "image/jpeg"];
    const finalMime = allowedMime.includes(mime) ? mime : "image/png";

    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: finalMime });
  };

  const handleSignatureSubmit = async () => {
    if (sigRef.current) {
      const dataURL = sigRef.current.toDataURL("image/png");
      setSignaturePreview(dataURL);

      const originalFileName = `signature-${Date.now()}.png`;
      const file = dataURLtoFile(dataURL, originalFileName); // Converts safely

      const secretKey = "your-strong-secret-key";
      const encryptedFileName = CryptoJS.AES.encrypt(
        originalFileName,
        secretKey
      ).toString();

      const fileWithEncryptedName = new File(
        [file],
        encryptedFileName + ".enc",
        { type: file.type }
      );

      const formData = new FormData();
      formData.append("file", fileWithEncryptedName);

      try {
        const response = await axios.post(
          "https://rmsl.geecomindia.in/api/uploadSignSeedDisribution",
          formData,
          {
            headers: {
              Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // Replace
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const uploadedFileName = response.data.data.filename;

        if (uploadedFileName) {
          const fullUrl = `${FILE_BASE_URL}signSeedDisribution/${uploadedFileName}`;
          setFormData((prev) => ({
            ...prev,
            Signature_Pad: fullUrl,
          }));
        }

        toggleModal();
        Swal.fire({
          title: "Signature Uploaded!",
          text: "Your signature has been uploaded successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        console.error("Upload failed:", error?.response?.data || error.message);
        Swal.fire({
          title: "Upload Failed",
          text: error?.response?.data?.message || "Unknown error occurred.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };
  const convertToPngBase64 = (bmpBase64Data) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const pngData = canvas.toDataURL("image/png"); // Converts to real PNG
        resolve(pngData);
      };
      img.src = bmpBase64Data;
    });
  };

  const handleFingerprintSubmit = async () => {
    if (!imageSrc) {
      Swal.fire({
        title: "No Fingerprint",
        text: "Please scan a fingerprint before submitting.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      // 🔄 Convert BMP base64 to PNG base64
      const pngBase64 = await convertToPngBase64(imageSrc);

      const originalFileName = `fingerprint-${Date.now()}.png`;
      const file = dataURLtoFile(pngBase64, originalFileName); // Real PNG file

      // 🔐 Encrypt filename using AES
      const secretKey = "your-strong-secret-key";
      const encryptedFileName = CryptoJS.AES.encrypt(
        originalFileName,
        secretKey
      ).toString();

      const fileWithEncryptedName = new File(
        [file],
        encryptedFileName + ".enc",
        { type: file.type }
      );

      const formData = new FormData();
      formData.append("file", fileWithEncryptedName);

      const response = await axios.post(
        "https://rmsl.geecomindia.in/api/uploadSignSeedDisribution",
        formData,
        {
          headers: {
            Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // Replace this
          },
        }
      );

      const uploadedFileName = response.data.data.filename;

      if (uploadedFileName) {
        const fullUrl = `${FILE_BASE_URL}signSeedDisribution/${uploadedFileName}`;
        setFormData((prev) => ({
          ...prev,
          Signature_Thumb: fullUrl,
        }));
      }

      setFingerprintModalOpen(false);

      Swal.fire({
        title: "Fingerprint Uploaded!",
        text: "Your fingerprint has been uploaded successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error(
        "Fingerprint upload failed:",
        error?.response?.data || error.message
      );
      Swal.fire({
        title: "Upload Failed",
        text: error?.response?.data?.message || "Unknown error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  const handleCapturedImageSubmit = async () => {
    if (capturedImage) {
      const originalFileName = `photo-${Date.now()}.png`;
      const file = dataURLtoFile(capturedImage, originalFileName); // Converts safely

      const secretKey = "your-strong-secret-key";
      const encryptedFileName = CryptoJS.AES.encrypt(
        originalFileName,
        secretKey
      ).toString();

      const fileWithEncryptedName = new File(
        [file],
        encryptedFileName + ".enc",
        {
          type: file.type,
        }
      );

      const formData = new FormData();
      formData.append("file", fileWithEncryptedName);

      try {
        const response = await axios.post(
          "https://rmsl.geecomindia.in/api/uploadSignSeedDisribution",
          formData,
          {
            headers: {
              Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // Replace
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const uploadedFileName = response.data.data.filename;
        console.log("✅ Encrypted and uploaded as filename:", uploadedFileName);

        if (uploadedFileName) {
          const fullUrl = `${FILE_BASE_URL}signSeedDisribution/${uploadedFileName}`;
          setFormData((prev) => ({
            ...prev,
            Farmer_Image: fullUrl, // or a different field if needed
          }));
        }

        setIsPopupOpen(false);
        setStep("camera");
        Swal.fire({
          title: "Image Uploaded!",
          text: "Your image has been uploaded successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        console.error("Upload failed:", error?.response?.data || error.message);
        Swal.fire({
          title: "Upload Failed",
          text: error?.response?.data?.message || "Unknown error occurred.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const videoConstraints = {
    facingMode: facingMode,
  };

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
    setStep("preview");
  }, [webcamRef]);

  const toggleCamera = () => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  };

  return (
    <div className="max-w-2xl mx-auto p-6 space-y-6">
      <div
        className="border-t border-l border-r border-b-0 rounded-t shadow bg-white p-4"
        style={{
          borderTopColor: borderColor,
          borderTopWidth: "4px",
          borderTopStyle: "solid",
        }}
      >
        <div className="flex items-center justify-between border-b pb-2 mb-4">
          <h2 className="text-2xl font-bold text-green-600">Seed Detail</h2>
          <button
            className="px-8 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            onClick={handleNavigate}
          >
            List
          </button>
        </div>

        <div
          className="max-w-xl mx-auto mt-10 mb-6 p-6 bg-white border-t-4 rounded-2xl text-gray-800 text-base shadow"
          style={{ borderTopColor: borderColor }}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6">
            <div className="text-base">
              <span className="font-semibold text-gray-600">Name:</span>{" "}
              {userData?.user?.User_Name?.replace(/"/g, "") || "NA"}
            </div>

            <div className="text-base">
              <span className="font-semibold text-gray-600">Father Name:</span>{" "}
              {userData?.responses?.FatherName?.replace(/"/g, "") || "NA"}
            </div>

            <div className="text-base">
              <span className="font-semibold text-gray-600">Village:</span>{" "}
              {userData?.responses?.Village?.replace(/"/g, "") || "NA"}
            </div>

            <div className="text-base">
              <span className="font-semibold text-gray-600">Area:</span>{" "}
              {userData?.responses?.Area?.replace(/"/g, "") || "NA"}
            </div>
          </div>
        </div>

        <div className="flex gap-4 mb-4">
          <div className="flex-1">
            <label className="block font-semibold text-black mb-1">
              Year<span className="text-red-600">*</span>
            </label>

            <Select
              value={
                yearOptions.find((opt) => opt.value === formData.Year) || null
              }
              onChange={(selectedOption) =>
                handleChange("Year", selectedOption?.value || "")
              }
              options={yearOptions}
              placeholder="Select Year"
              isSearchable
              classNamePrefix={
                formErrors.Year ? "react-select-error" : "react-select"
              }
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderRadius: "0.5rem",
                  padding: "2px",
                  borderColor: formErrors.Year ? "#f87171" : "#d1d5db",
                  boxShadow: state.isFocused
                    ? `0 0 0 2px ${formErrors.Year ? "#f87171" : "#4ade80"}`
                    : undefined,
                  "&:hover": {
                    borderColor: formErrors.Year ? "#f87171" : "#4ade80",
                  },
                }),
              }}
            />

            {formErrors.Year && (
              <p className="text-red-500 text-sm">{formErrors.Year}</p>
            )}
          </div>

          <div className="flex-1">
            <label className="block font-semibold text-black mb-1">
              Crop<span className="text-red-600">*</span>
            </label>
            <select
              className={`w-full border p-2 rounded transition-colors duration-200 ${
                formErrors.Crop_ID ? errorStyle : "border-gray-300"
              } hover:border-green-400 focus:outline-none focus:ring-2 focus:ring-green-400`}
              value={formData.Crop_ID}
              onChange={(e) => handleChange("Crop_ID", e.target.value)}
            >
              <option value="">Select Crop</option>
              {cropOptions.map((crop) => (
                <option key={crop.id} value={crop.id}>
                  {crop.name}
                </option>
              ))}
            </select>
            {formErrors.Crop_ID && (
              <p className="text-red-500 text-sm">{formErrors.Crop_ID}</p>
            )}
          </div>

          <div className="flex-1">
            <label className="block font-semibold text-black mb-1">
              Season<span className="text-red-600">*</span>
            </label>
            <select
              className="w-full border p-2 rounded bg-gray-100 text-gray-500 border-gray-300 cursor-not-allowed"
              defaultValue="Kharif"
              disabled
            >
              <option value="Kharif">Kharif</option>
            </select>
          </div>
        </div>

        <div
          className="mb-4 shadow p-3 rounded border-t-4"
          style={{ borderTopColor: borderColor }}
        >
          <label className="block font-semibold text-black mb-1">
            Variety<span className="text-red-600">*</span>
          </label>

          <Select
            value={
              varietySelectOptions.find(
                (opt) => opt.value === formData.Variety_ID
              ) || null
            }
            onChange={(selectedOption) =>
              handleChange("Variety_ID", selectedOption?.value || "")
            }
            options={varietySelectOptions}
            placeholder="Select Variety"
            isSearchable
            classNamePrefix={
              formErrors.Variety_ID ? "react-select-error" : "react-select"
            }
            styles={{
              control: (base, state) => ({
                ...base,
                borderRadius: "0.5rem",
                padding: "2px",
                borderColor: formErrors.Variety_ID ? "#f87171" : "#d1d5db", // red or gray
                boxShadow: state.isFocused
                  ? `0 0 0 2px ${formErrors.Variety_ID ? "#f87171" : "#4ade80"}` // red-400 or green-400
                  : undefined,
                "&:hover": {
                  borderColor: formErrors.Variety_ID ? "#f87171" : "#4ade80",
                },
              }),
            }}
          />

          {formErrors.Variety_ID && (
            <p className="text-red-500 text-sm">{formErrors.Variety_ID}</p>
          )}
        </div>

        <div
          className="mb-4 shadow p-3 rounded border-t-4"
          style={{ borderTopColor: borderColor }}
        >
          <label className="block font-semibold text-black mb-1">
            NO OF PACKET<span className="text-red-600">*</span>
          </label>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="NO OF PACKET"
            className={`w-full border p-2 rounded transition-colors duration-200 focus:outline-none focus:ring-2 ${
              formErrors.No_Of_Packet
                ? `${errorStyle} focus:ring-red-400`
                : "border-gray-300 hover:border-green-400 focus:ring-green-400"
            }`}
            value={formData.No_Of_Packet}
            onChange={(e) => {
              const value = e.target.value;
              // Allow only digits (no letters, no symbols, no negative, no decimal)
              if (/^\d*$/.test(value)) {
                handleChange("No_Of_Packet", value);
              }
            }}
          />

          {formErrors.No_Of_Packet && (
            <p className="text-red-500 text-sm">{formErrors.No_Of_Packet}</p>
          )}
        </div>

        <div
          className="mb-4 shadow p-3 rounded border-t-4"
          style={{ borderTopColor: borderColor }}
        >
          <label className="block font-semibold text-black mb-1">
            Lot No.<span className="text-red-600">*</span>
          </label>

          <Select
            value={
              lotSelectOptions.find((opt) => opt.value === formData.LotNo) ||
              null
            }
            onChange={(selectedOption) =>
              handleChange("LotNo", selectedOption?.value || "")
            }
            options={lotSelectOptions}
            placeholder="-- Select Lot No. --"
            isSearchable
            classNamePrefix={
              formErrors.LotNo ? "react-select-error" : "react-select"
            }
            styles={{
              control: (base, state) => ({
                ...base,
                borderRadius: "0.5rem",
                padding: "2px",
                borderColor: formErrors.LotNo ? "#f87171" : "#d1d5db",
                boxShadow: state.isFocused
                  ? `0 0 0 2px ${formErrors.LotNo ? "#f87171" : "#4ade80"}`
                  : undefined,
                "&:hover": {
                  borderColor: formErrors.LotNo ? "#f87171" : "#4ade80",
                },
              }),
            }}
          />

          {formErrors.LotNo && (
            <p className="text-red-500 text-sm">{formErrors.LotNo}</p>
          )}
        </div>

        <div
          className="mb-4 shadow p-3 rounded border-t-4"
          style={{ borderTopColor: borderColor }}
          onClick={() => dateInputRef.current?.showPicker()} // trigger calendar on div click
        >
          <label className="block font-semibold text-black mb-1">
            DATE OF DISTRIBUTION<span className="text-red-600">*</span>
          </label>
          <input
            ref={dateInputRef}
            type="date"
            className={`w-full border p-2 rounded cursor-pointer transition-colors duration-200 focus:outline-none focus:ring-2 ${
              formErrors.Date_of_Distributation
                ? `${errorStyle} focus:ring-red-400`
                : "border-gray-300 hover:border-green-400 focus:ring-green-400"
            }`}
            value={formData.Date_of_Distributation}
            onChange={(e) =>
              handleChange("Date_of_Distributation", e.target.value)
            }
          />
          {formErrors.Date_of_Distributation && (
            <p className="text-red-500 text-sm">
              {formErrors.Date_of_Distributation}
            </p>
          )}
        </div>

        <div
          className="shadow p-3 rounded border-t-4 mb-4"
          style={{ borderTopColor: borderColor }}
        >
          <label className="block font-semibold text-black mb-2">
            Scan Fingerprint
          </label>
          <button
            type="button"
            onClick={() => setFingerprintModalOpen(true)}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            🌟 Click to Scan Fingerprint
          </button>
          {/* {formErrors.Signature_Thumb && (
            <p className="text-red-500 text-sm">{formErrors.Signature_Thumb}</p>
          )} */}
          {imageSrc && (
            <>
              <h3 style={{ marginTop: "30px" }}>Scanned Image:</h3>
              <img
                src={imageSrc}
                alt="Fingerprint"
                height="300"
                width="210"
                style={{ border: "2px solid black" }}
              />
            </>
          )}
        </div>

        <div
          className="shadow p-3 rounded border-t-4 mb-4"
          style={{ borderTopColor: borderColor }}
        >
          <label className="block font-semibold text-black mb-2">
            Digital Signature
          </label>
          <button
            type="button"
            onClick={toggleModal}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            ✍️ Draw Signature
          </button>
          {/* {formErrors.Signature_Pad && (
            <p className="text-red-500 text-sm">{formErrors.Signature_Pad}</p>
          )} */}
          {signaturePreview && (
            <div className="mt-4">
              <h3 className="text-lg font-medium mb-2">Signature Preview:</h3>
              <img
                src={signaturePreview}
                alt="Digital Signature"
                style={{
                  border: "1px solid #ccc",
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </div>
          )}
        </div>
        <div
          className="shadow p-3 rounded border-t-4 mb-4"
          style={{ borderTopColor: borderColor }}
        >
          <label className="block font-semibold text-black mb-2">
            Capture Image
          </label>
          <button
            type="button"
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            onClick={() => setIsPopupOpen(true)}
          >
            📸 Capture Image
          </button>
          {/* {formErrors.Farmer_Image && (
            <p className="text-red-500 text-sm">{formErrors.Farmer_Image}</p>
          )} */}
          {/* Signature Preview Below the Button */}
          {capturedImage && (
            <div className="mt-4">
              <h3 className="text-lg font-medium mb-2">
                Captured Image Preview:
              </h3>
              <img
                src={capturedImage}
                alt="Captured"
                className="border border-gray-300 max-w-full h-auto"
              />
            </div>
          )}

          {/* Popup */}
          {isPopupOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
              <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
                {/* Close Button */}
                <button
                  onClick={() => {
                    setIsPopupOpen(false);
                    setStep("camera");
                  }}
                  className="absolute top-2 right-2 text-gray-500 hover:text-black"
                >
                  ✖
                </button>

                {/* Camera Tab */}
                {/* Camera Tab */}
                {step === "camera" && (
                  <>
                    <h2 className="text-xl font-semibold mb-4 text-center">
                      📷 Capture Image
                    </h2>
                    <Webcam
                      audio={false}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={videoConstraints}
                      className="w-full rounded"
                    />
                    <div className="mt-4 flex justify-between">
                      <button
                        onClick={toggleCamera}
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                      >
                        🔄 Switch Camera
                      </button>
                      <button
                        onClick={capture}
                        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                      >
                        📸 Next
                      </button>
                    </div>
                  </>
                )}

                {/* Preview Tab */}
                {step === "preview" && (
                  <>
                    <h2 className="text-xl font-semibold mb-4 text-center">
                      🖼️ Captured Image
                    </h2>
                    <img
                      src={capturedImage}
                      alt="Captured Preview"
                      className="w-full rounded"
                    />
                    <div className="mt-4 flex justify-between">
                      <button
                        onClick={() => setStep("camera")}
                        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                      >
                        🔙 Back
                      </button>
                      <button
                        onClick={handleCapturedImageSubmit}
                        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                      >
                        ✅ Use Image
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Modal */}
        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative bg-white p-6 rounded-lg shadow-2xl w-full max-w-2xl">
              <button
                className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl"
                onClick={toggleModal}
                aria-label="Close"
              >
                &times;
              </button>

              <h2 className="text-2xl font-semibold mb-4 text-center">
                Add Signature
              </h2>

              <SignatureCanvas
                penColor={penColor}
                canvasProps={{
                  width: 500,
                  height: 200,
                  className: "border border-gray-300 rounded-md w-full",
                }}
                ref={sigRef}
              />

              <div className="mt-4 flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center space-x-3">
                  <label className="font-medium">Pen Color:</label>
                  <input
                    type="color"
                    value={penColor}
                    onChange={(e) => setPenColor(e.target.value)}
                    className="border rounded w-10 h-10 p-1"
                  />
                </div>

                <div className="flex space-x-3">
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
                    onClick={clearSignature}
                  >
                    Clear
                  </button>
                  <button
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    onClick={handleSignatureSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {isFingerprintModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative bg-white p-6 rounded-lg shadow-2xl w-full max-w-2xl">
              <button
                className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl"
                onClick={() => setFingerprintModalOpen(false)}
                aria-label="Close"
              >
                &times;
              </button>

              <h2 className="text-2xl font-semibold mb-4 text-center">
                Scan Fingerprint
              </h2>

              <div className="flex flex-col items-center gap-4">
                <button
                  onClick={captureFP}
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                  🖐 Start Fingerprint Scan
                </button>
                {formErrors.Signature_Thumb && (
                  <p className="text-red-500 text-sm">
                    {formErrors.Signature_Thumb}
                  </p>
                )}
                {imageSrc && (
                  <div className="text-center">
                    <h3 className="text-lg font-medium mb-2">Scanned Image:</h3>
                    <img
                      src={imageSrc}
                      alt="Fingerprint"
                      height="300"
                      width="210"
                      style={{ border: "2px solid black" }}
                    />
                  </div>
                )}

                <div className="flex gap-4 mt-4">
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                    onClick={() => {
                      setImageSrc(null); // clear preview
                    }}
                  >
                    Clear
                  </button>
                  <button
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    onClick={handleFingerprintSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="text-right">
          <button
            onClick={handleSubmit}
            className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataCollection;
